module.exports = __webpack_public_path__ + "static/media/logo-saham.4c7cfa0d.svg";